AppBase.module('Entities', function (Module, App, Backbone) {
  'use strict'
  var PhoneNumbers = Backbone.Collection.extend({
    url: '/utilities/normalize_phone_number',

    /**
     * Sort the numbers by country code. `formatted` comes in as e.g.
     * `+1 (202) 456-1111`; the country code is the first set of digits.
     *
     * @param model {Backbone.Model} model to evaluate
     * @return {Number} the country code
     */
    comparator: function (model) {
      var country_code = model.get('formatted').split(/\s/)[0]
      return parseInt(country_code, 10)
    },

    parse: function (data) {
      var numbers = data.numbers

      var processed = numbers.map(function (number) {
        number.images = {
          classes: ['f16', 'flag-' + number.abbreviation.toLowerCase()],
          type: 'custom',
        }
        number.secondary_text = number.territory
        number.text = number.formatted

        return number
      })

      return processed
    },
  })
  Module.PhoneNumbers = PhoneNumbers
})
